angular.module("richiestaLpf.components", []).component("richiestaLpf", {
  templateUrl: "ng/components/richiestaLpf/richiestaLpf.view.html",
  bindings: {
    richiestePostVendita: "="
  },
  controllerAs: "richiestaLpfCtrl",
  controller: function richiestaLpf(
    $RichiestePostVenditaService,
    $modalService,
    $location,
    $configService,
    $download
  ) {
    var self = this;

    self.$onInit = function () {

      self.filter = {
        limit: 10,
        offset: 0,
        pageIndex: 1,
        totalPages: 0,
      };

      self.supportModel = {
        ctrRichiestaList: [],
        listaContratti: [],
        listaDocumenti: [],
        nextStep: false,
        spesaAccepted: false,
        selectedAll: false
      };

      self.restIsPending = true;
      self.ricercaEffettuata = false;
      self.visibleDownloadChecklist = false;
      self.visibleUploadChecklist = false;

      retrieveStepInfo();
      self.retrieveContracts();
    };

    var retrieveStepInfo = function () {
      self.clearLabelInfo = true;
      self.restStepInfo = true;
      $RichiestePostVenditaService
        .getStepInfo(
          self.richiestePostVendita.id,
          self.richiestePostVendita.viewIndex
        )
        .then(function (response) {
          if (response.success) {
            self.showMapInfo = response.showBeMessage;
            self.mapInfo = response.message;
            self.restStepInfo = false;
          }
          self.clearLabelInfo = false;
        })
        .catch(function (error) {
          console.log(error);
          self.restStepInfo = false;
          self.clearLabelInfo = false;
        });
    };

    self.retrieveContracts = function () {
      $RichiestePostVenditaService
        .getContractsLpf()
        .then(function (response) {
          self.restIsPending = false;
          if (response.success) {
            self.supportModel.listaContratti = response.listContratti;
            if (self.richiestePostVendita.ctrRichiestaList && self.richiestePostVendita.ctrRichiestaList.length && self.supportModel.listaContratti.length) {
              self.supportModel.listaContratti.forEach(function (element) {
                self.richiestePostVendita.ctrRichiestaList.forEach(function (el) {
                  if (element.numeroContratto == el.numeroContratto) {
                    element.selected = true;
                  }
                })
              })
            }
            self.supportModel.listaContratti.forEach(function (element) {
              self.richiestePostVendita.metadata.ctrRichiestaList.forEach(function (el) {
                if (element.numeroContratto == el.numeroContratto) {
                  element.selected = true;
                }
              })
            })
          }
        })
        .catch(function (error) {
          console.log(error);
          self.isPending = false;
        });
    };

    self.check = function (el) {
      el.selected = !el.selected;
      self.richiestePostVendita.metadata.ctrRichiestaList =
        self.supportModel.listaContratti.filter(function (element) {
          return element.selected == true;
        });
    };

    self.checkSelected = function () {
      return self.supportModel.listaContratti.some(function (element) {
        return element.selected == true;
      });
    };

    self.checkArchive = function () {
      self.ricercaEffettuata = true;
      self.documentIsPending = true;
      $RichiestePostVenditaService
        .getDocumentsLpf(self.filter)
        .then(function (response) {
          if (response.success == true) {
            self.supportModel.listaDocumenti = response.documents;
          }
          self.documentIsPending = false;
        })
        .catch(function (error) {
          console.log(error);
          self.documentIsPending = false;
        });
    };

    self.acceptExpense = function () {
      self.supportModel.nextStep = true;
      $RichiestePostVenditaService.showSpesaLpf(self.richiestePostVendita)
        .then(function (response) {
          if (response.success) {
            self.message = response.message;
            self.listaSpese = response.spese;
            self.showLoader = false;
            $modalService.openModal("showSpesa")
            self.supportModel.nextStep = false;
          }
        })
        .catch(function (error) {
          console.log(error);
          self.supportModel.nextStep = false;
          self.showLoader = false;
        })
    }

    self.next = function () {
      self.supportModel.nextStep = true;
      $RichiestePostVenditaService
        .submitRequestLpf(
          self.richiestePostVendita,
        )
        .then(function (response) {
          if (response.success) {
            $modalService.closeModal("showSpesa");
            $location.path("/");
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          self.supportModel.nextStep = false;
        });
    };

    self.closeModal = function (modal) {
      if (modal === "suspend") {
        $modalService.closeModal("suspendInstance");
      } else {
        $modalService.closeModal("showSpesa");
      }
    };

    self.sospendi = function () {
      $RichiestePostVenditaService
        .suspendInstance(
          self.richiestePostVendita,
          self.richiestePostVendita.typeWf,
          self.richiestePostVendita.applicationName,
          true
        )
        .then(function () {
          $location.path("/");
          $modalService.closeModal("suspendInstance");
        });
    };

    self.generateDownload = function (idDocAlbagreen, cdDocNsil) {
      var url = "/arc/downloadDocument/service-infos/" +
        encodeURIComponent(idDocAlbagreen) +
        "/" +
        encodeURIComponent(cdDocNsil) +
        "/";



      $download.getGenericDownload(url)
        .then(function (response) {
          console.log(response);
        })


    }

    self.selectDeselectAll = function (value) {
      value.selectedAll = !value.selectedAll;

      self.supportModel.listaContratti.forEach(function (element) {
        element.selected = value.selectedAll;
      })
      self.richiestePostVendita.metadata.ctrRichiestaList =
        self.supportModel.listaContratti.filter(function (element) {
          return element.selected;
        });
    }

    self.downloadScontistica = function () {

      var url = "/uni/download/service-infos/SCONTI/";
      $download.getGenericDownload(url)
        .then(function (response) {
          console.log(response)
        })
    }
  },
});